<ng-container [formGroup]="newEditForm">
    <td class="short" [ngClass]="{'show-error': showError}">
        <app-filterable-list [itemsList]="marcas" [selectedItem]="newEditForm.get('marca')" [disabled]="disabledMarca" [placeHolder]="false">
        </app-filterable-list>
    </td>
    <td class="entry" *ngIf="this.role === 'Administrador'" [ngClass]="{'show-error': showError}">
        <app-filterable-list [itemsList]="allGrupoEtiquetasCaja" [selectedItem]="newEditForm.get('grupoEtiquetasCaja')"
            [disabled]="disabledCaja" [placeHolder]="false">
        </app-filterable-list>
    </td>
    <td class="entry" *ngIf="this.role === 'Administrador'" [ngClass]="{'show-error': showError}">
        <app-filterable-list [itemsList]="allGrupoEtiquetasPallet"
            [selectedItem]="newEditForm.get('grupoEtiquetasPallet')" [disabled]="disabledPallet" [placeHolder]="false">
        </app-filterable-list>
    </td>
    <td class="short" *ngIf="role === 'Administrador' || this.claims.includes('ETQ_MPD_Upd_ImpAut')">
        <input type="checkbox" id="{{'autorizado' + randomId}}" formControlName="impresionAutorizada">
        <label for="{{'autorizado' + randomId}}" style="margin-bottom: unset;"></label>
    </td>
    <td class="short" *ngIf="role === 'Administrador' || this.claims.includes('ETQ_MPD_Upd_ReimpAut')">
        <input type="checkbox" id="{{'reimp' + randomId}}" formControlName="reimpresionAutorizada">
        <label for="{{'reimp' + randomId}}" style="margin-bottom: unset;"></label>
    </td>
    <td class="multi-actions">
        <ng-container *ngIf="editable">
            <i class="far fa-save" title="{{'titles.guardar' | translate}}" (click)="save()"></i>
            <i class="fas fa-times" title="{{'global.cancelar' | translate}}" (click)="cancel()"></i>
        </ng-container>
        <ng-container *ngIf="!editable">
            <i class="fas fa-pencil-alt" title="{{'titles.editar' | translate}}" (click)="edit(etiquetador)"></i>
            <i class="far fa-trash-alt" *ngIf="this.role === 'Administrador'" title="{{'titles.eliminar' | translate}}" app-click-stop-propagation (click)="askDelete(etiquetador)"></i>
        </ng-container>
    </td>
</ng-container>
<app-toast *ngIf="showError && mensajes" [messages]="mensajes" (closed)="showError=$event"></app-toast>
<div class="modal" *ngIf="deleteModal">
    <div class="modal-content">
        <header>
            <h4>{{'global.eliminar.descripcion' | translate}}</h4>
        </header>
        <content>
            <p>{{'global.eliminar.confirmacion' | translate}}</p>
        </content>
        <footer>
            <button class="secondary" (click)="closeModal()">{{'global.cancelar' | translate}}</button>
            <button (click)="delete()">{{'global.confirmar' | translate}}</button>
        </footer>
    </div>
</div>